module.exports = __webpack_public_path__ + "static/media/signage-industrial-img29.99a84205.jpg";